import '@babel/polyfill'
import Vue from 'vue'
import Vuelidate from 'vuelidate'

import { create as createApi } from '@/api'
import '@/components/registerAsGlobal'
import '@/filters/registerAsGlobal'
import i18n from '@/lang/i18n'
import '@/plugins'
import router from '@/router'
import store from '@/store'
import '@/router/syncWithVuex'
import routerBeforeEach from '@/router/beforeEach'
import 'ag-grid-enterprise'

import App from './App.vue'

const $DEV = process.env.NODE_ENV === 'development'

Vue.config.productionTip = process.env.NODE_ENV === 'production'
Vue.prototype.$DEV = $DEV

routerBeforeEach({ store, router })

createApi({
    actions: {
        onSignout: () => router.push({ name: 'Signout' }),
        sendNotification: notification => store.dispatch('notification/send', notification),
        sendError: notification => store.dispatch('notification/error', notification),
    },
})

console.loggy = (arg, ...rest) => {
    if ($DEV) console.log(arg, ...rest)
    return arg
}

/**
 * Remove console.error for the agGrid enterprise version in PROD
 */
if (!$DEV) {
    (window.console || {}).error = () => {}
}


const app = new Vue({
    router,
    store,
    i18n,
    Vuelidate,
    render: h => h(App),
}).$mount('#app')

window.app = app
